import { type ReactNode } from "react";

export function MasteryLegend(): ReactNode {
  return (
    <details className="border border-ink/10 bg-paperWarm/40 mb-6">
      <summary className="cursor-pointer select-none px-4 py-2 text-xs font-mono uppercase tracking-widest text-inkSoft hover:text-ink">
        What do these mean?
      </summary>
      <ul className="px-4 pb-3 pt-1 space-y-1.5 text-sm">
        <LegendRow swatch="bg-success" term="Mastered">
          stability of 30+ days. The skill has stuck.
        </LegendRow>
        <LegendRow swatch="bg-info" term="Practicing">
          stability of 7+ days with no recent slip-ups.
        </LegendRow>
        <LegendRow swatch="bg-warning/40" term="Introduced">
          you&apos;ve started this, but it isn&apos;t yet sticking.
        </LegendRow>
      </ul>
    </details>
  );
}

function LegendRow({
  swatch,
  term,
  children,
}: {
  swatch: string;
  term: string;
  children: ReactNode;
}): ReactNode {
  return (
    <li className="flex items-baseline gap-2">
      <span className={`inline-block h-2 w-2 ${swatch} flex-shrink-0`} aria-hidden />
      <span className="font-medium text-ink">{term}</span>
      <span className="text-inkSoft font-serif italic">— {children}</span>
    </li>
  );
}
